import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { submitFilterDTO } from 'src/components/Common/UI/DndTable/types';


const convertToDataTable = (data: IGetModelType[]): IGetModelType[] => {
  const dataTableData: IGetModelType[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllModelTypes = async ( {data} : {data: submitFilterDTO | {}}): Promise<IGetModelType[]> => {
  const response =  await axiosDefaultApi.post(`/api/Entities/GetData/Model_Types`, data);
  return convertToDataTable(response as unknown as IGetModelType[]);
};

type QueryFnType = typeof getAllModelTypes;

type UseGetAllModelTypesOptions = {
  data: submitFilterDTO | {};
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllModelTypes = ({ data, config }: UseGetAllModelTypesOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllModelTypes'],
    queryFn: () => getAllModelTypes({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};